export const SINGLETON_KEY = '_global_singleton_instance'
export const NCART_KEY = 'ncart';